export function enableJS() {
  document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, '');
}

export function isAppleDevice() {
  const iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ];

  if (navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }

  return false;
}

export function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}
